module.exports = __webpack_public_path__ + "img/20_dice[16].19b28118.png";